import axios from "axios";

const instance2 = axios.create({
  baseURL: process.env.REACT_APP_API2_BASE_URL,
  responseType: "json",
  timeout: 30000,
});

instance2.interceptors.response.use((response) => {
  return response;
});

// Skywayを用いたビデオチャット
// 患者用用skyway Tokenの取得
export const getSkywayToken = (data) => {
  return instance2.post("/generateSkyWayTokenForCustomer", data);
};

// 入室中フラグの更新
export const updateRoomEntry = (data) => {
  return instance2.put("/updateSkywayRoomEntryStatusForCustomer", data);
};
